import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
// @ts-ignore: CSS import declaration file missing
import './index.css'
import App from './pages/App/App'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
    <React.StrictMode>
        <Suspense fallback="loading">
            <App />
        </Suspense>
    </React.StrictMode>
)